<template>
  <div>
    <template v-if="contents">
      <div :class="['component', previewSize]" :style="hideAll ? 'display:none' : ''">
        <div @click="isEditing = !isEditing">

          <section :class="sectionClassArray" :style="sectionStyle">
            <div :class="containerClassArray">
              <template v-if="contents.src">
                <div class="smartphone-size">
                  <div class="iframe-wrapper" :style="'height:'+contents.height.s+'px'">
                    <iframe class="iframe" :src="contents.src" :height="contents.height.s" frameborder="0" style="border:0" allowfullscreen></iframe>
                    <div class="iframe-overlay"></div>
                  </div>
                </div>
                <div class="tablet-size">
                  <div class="iframe-wrapper" :style="'height:'+contents.height.m+'px'">
                    <iframe class="iframe" :src="contents.src" :height="contents.height.m" frameborder="0" style="border:0" allowfullscreen></iframe>
                    <div class="iframe-overlay"></div>
                  </div>
                </div>
                <div class="desktop-size">
                  <div class="iframe-wrapper" :style="'height:'+contents.height.l+'px'">
                    <iframe class="iframe" :src="contents.src" :height="contents.height.l" frameborder="0" style="border:0" allowfullscreen></iframe>
                    <div class="iframe-overlay"></div>
                  </div>
                </div>
              </template>
              <template v-else>
                <div class="component-warning flex justify-center items-center">
                  <span class="component-warning-span">ここをクリックして表示する外部サイトを設定してください</span>
                </div>
              </template>
            </div>
          </section>

        </div>
      </div>
      <el-form :class="['component-contents-form', ' p2', lock ? 'hide' : isEditing ? 'show' : 'hide']" :model="contents">
        <h2>コンポーネントのコンテンツを編集</h2>
        <el-form-item label="コンポーネント配置順序" :label-width="labelWidth">
          <el-input-number v-model="newPosition" controls-position="right" :min="1" :max="positionMax"></el-input-number><span class="pl4">1から{{ positionMax }}まで</span>
        </el-form-item>
        <el-form-item label="外部サイトのURL" :label-width="labelWidth">
          <el-input type="textarea" :autosize="{minRows:2}" v-model="contents.src" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="最大幅の設定" :label-width="labelWidth">
          <el-checkbox v-model="contents.fullWidth">最大幅で表示する</el-checkbox>
        </el-form-item>
        <el-form-item label="表示領域の高さ (px)" :label-width="labelWidth">
          <div class="flex flex-wrap items-center">
            <div style="margin-right:1.5rem">
              <div>スマホサイズ</div>
              <el-input-number v-model="contents.height.s" controls-position="right" :min="1"></el-input-number>
            </div>
            <div style="margin-right:1.5rem">
              <div>タブレットサイズ</div>
              <el-input-number v-model="contents.height.m" controls-position="right" :min="1"></el-input-number>
            </div>
            <div style="margin-right:1.5rem">
              <div>デスクトップサイズ</div>
              <el-input-number v-model="contents.height.l" controls-position="right" :min="1"></el-input-number>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="スライド上下の余白" :label-width="labelWidth">
           <el-slider v-model="contents.padding.y" :step="1" :min="0" :max="10"></el-slider>
        </el-form-item>
        <el-form-item label="スライド背景色" :label-width="labelWidth">
          <div>
            <el-checkbox v-model="contents.bg.isCustom">スライドの背景色を指定する</el-checkbox>
          </div>
          <div class="items-center" :style="{display: contents.bg.isCustom ? 'flex' : 'none'}">
            <el-color-picker v-model="contents.bg.color" show-alpha></el-color-picker>
            <span>{{ contents.bg.color }}</span>
          </div>
        </el-form-item>
        <div class="component-contents-controller flex justify-end items-center">
          <component-form-footer @delete="deleteComponent()" @cancel="isEditing = false" @update="updateComponent()"></component-form-footer>
        </div>
      </el-form>
    </template>
  </div>
</template>

<script>
import ComponentBase from '@/components/mixins/ComponentBase'

export default {
  name: 'iframe-1',
  mixins: [ComponentBase],
  data: function () {
    return {
      labelWidth: '220px'
    }
  },
  methods: {
    /**
     * this.contentsからコンポーネントのHTMLを生成
     */
    generateHtml: function (contents) {
      return `
      <section id="${this.sectionId}" class="${this.sectionClass}">
        <div class="${this.containerClass}">
          <amp-iframe class="amp-iframe" height="${contents.height.l}" layout="fixed-height" sandbox="allow-scripts allow-same-origin" frameborder="0" src="${contents.src}"><div placeholder><span class="placeholder flex justify-center items-center">${contents.src}</span></div></amp-iframe>
        </div>
      </section>
      `.trim().replace(/>\s+</g, '><')
    },
    /**
     * this.contentsからコンポーネントのCSSを生成
     */
    generateCss: function (contents) {
      let layout = require(`!css-to-string-loader!css-loader?minimize!sass-loader!./${this.meta.file}.scss`)
      layout += `.${this.meta.file} .amp-iframe{max-height:${contents.height.s}px}
      @media (min-width: 768px) {.${this.meta.file} .amp-iframe{max-height:${contents.height.m}px}}
      @media (min-width: 1025px) {.${this.meta.file} .amp-iframe{max-height:${contents.height.l}px}}`
      let theme = contents.bg.isCustom ? `.${this.meta.file}-${this._uid}-bg{background-color:${contents.bg.color}}` : ''
      return {layout, theme}
    }
  },
  created: async function () {
    if (!this.posts.length) await this.$store.dispatch('wordpress/posts/fetch')

    // migration
    if (!this.contents.padding) this.contents.padding = {y: 0}
  }
}
</script>

<style lang="scss">
.el-form-item {
  display: flex;
  align-items: center;
  &__label {
    float: none;
    line-height: 1.2;
    text-align: left;
  }
  &__content {
    margin-left: 0 !important;
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
.native {
  @import './Iframe1.scss';
}
.smartphone,
.tablet,
.desktop {
  @import './Iframe1.s.scss';
}
.tablet,
.desktop {
  @import './Iframe1.m.scss';
}
.desktop {
  @import './Iframe1.l.scss';
}

.smartphone-size {
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
}
.tablet-size {
  display: none;
  @media (min-width: 768px) and (max-width: 1024px) {
    display: block;
  }
}
.desktop-size {
  display: none;
  @media (min-width: 1025px) {
    display: block;
  }
}

.iframe {
  width: 100%;
  height: 100%;
  &-wrapper {
    position: relative;
  }
  &-overlay {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/contents/Iframe1/Iframe1.vue